



























































































import { computed, defineComponent } from '@vue/composition-api';
import { v4 } from 'uuid';
import CtaButton from '@front-app/components/buttons/CtaButton.vue';
import { ButtonPalettes } from '@front-app/components/buttons/palettes';
import { Size } from '@front-app/components/constants';
import ConfirmationModalButtons from './ConfirmationModalButtons.vue';
import TrModal from './TrModal.vue';

export default defineComponent({
	components: {
		ConfirmationModalButtons,
		CtaButton,
		TrModal,
	},
	props: {
		hasError: Boolean,
		hasWarning: Boolean,
		isCancelDisabled: Boolean,
		isReversed: Boolean,
		title: {
			type: String,
			default: '',
		},
		confirmLabel: {
			type: String,
			default: '',
		},
		cancelLabel: {
			type: String,
			default: '',
		},
		closeButtonAriaLabel: {
			type: String,
			default: '',
		},
		ariaLabelledby: {
			type: String,
			default: '',
		},
		modalClass: {
			type: String,
			default: 'confirmation-modal__inner',
		},
	},
	setup(props) {
		const innerHeaderId = `modal_header_${v4()}`;
		const headerId = computed(() => props.ariaLabelledby || innerHeaderId);
		return {
			headerId,
			ButtonPalettes,
			Size,
		};
	},
});
